<template>
    <div v-if="false"></div>
</template>

<script>
import MapLibreLayer from '@geoblocks/ol-maplibre-layer'
import {XYZ} from 'ol/source'
import {Attribution} from "ol/control";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

export default {
    name: 'MaplibreLayer',
    inject: ['map'],
    created() {
        this.maplibreLayer = new MapLibreLayer({
            name: this.name,
            maplibreOptions: this.options,

        })
        this.map.addLayer(this.maplibreLayer)

        const dummyLayer = new VectorLayer({
          source: new VectorSource({
            attributions: [
              'Kaartgegevens © MapTiler © OpenStreetMap bijdragers\n',
            ],
          }),
          visible: true,
        })

        this.map.addLayer(dummyLayer)

        const attributionControl = new Attribution({
          collapsible: false,
          collapsed: false,
        })
        this.map.addControl(attributionControl)
    },
    unmounted() {
    },
    props: {
        name: String,
        features: Array,
        styleName: String,
        selectable: Boolean,
        options: Object,
    }
}
</script>

<style scoped>
</style>
